import React from 'react';
import { FormattedMessage } from 'react-intl';

import { applyCSVFormatters } from './utils';
import messages from './messages';

import CSVLink from './components/CSVLink';
import FooterContainer from './components/FooterContainer';

const Footer = ({ filename, data, headers }) => (
    <FooterContainer>
        <CSVLink filename={filename} headers={headers} data={applyCSVFormatters(data, headers)}>
            <FormattedMessage {...messages.footer.export} />
        </CSVLink>
    </FooterContainer>
);

export default Footer;
